import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class ToggleController extends Controller {
  connect() {
    this.toggleTarget(this.togglerTarget.checked);
  }

  onTogglerChange(e) {
    let state = e.target.checked;

    if (e.target.hasAttribute('data-hide-content')) {
      state = false;
    }

    this.toggleTarget(state);
  }

  toggleTarget(state) {
    this.contentTarget.hidden = !state;

    const fields = toArray(this.contentTarget.querySelectorAll('input, select, textarea'));

    fields.forEach((field) => this.toggleRequiredOnField(field, state));
  }

  // eslint-disable-next-line class-methods-use-this
  toggleRequiredOnField(field, state) {
    if (!field.hasAttribute('data-required')) return;

    field[state ? 'setAttribute' : 'removeAttribute']('required', true);
  }
}

ToggleController.targets = [
  'toggler',
  'content',
];

export default ToggleController;
